module.exports = __webpack_public_path__ + "static/media/loading.d98163da.svg";